import { render, staticRenderFns } from "./ContentCounters.vue?vue&type=template&id=268fe4b6&scoped=true"
import script from "./ContentCounters.vue?vue&type=script&lang=js"
export * from "./ContentCounters.vue?vue&type=script&lang=js"
import style0 from "./ContentCounters.vue?vue&type=style&index=0&id=268fe4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fe4b6",
  null
  
)

export default component.exports